import Typeahead from '../Typeahead';

function NcfReviewRequestModal({
  onClose,
  onSend,
  reviewers,
  selections,
  setSelections,
  enabledRoles,
  setEnabledRoles,
  reviewNotNecessary,
  setReviewNotNecessary,
  additionalRecipients,
  setAdditionalRecipients,
  customMessage,
  setCustomMessage,
  searchRecipients,
  createRecipient,
  error
}) {
  const addRecipient = (option) => {
    const recipient = option?.raw;
    if (!recipient || additionalRecipients.some(item => item.email.toLowerCase() === recipient.email.toLowerCase())) return;
    setAdditionalRecipients(previous => [...previous, recipient]);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={event => event.stopPropagation()}>
        <div className="modal-header">
          <h2>Send NCF for review</h2>
          <button type="button" onClick={onClose} className="close-btn">✕</button>
        </div>
        <label className="ncf-review-not-needed">
          <input type="checkbox" checked={reviewNotNecessary} onChange={event => setReviewNotNecessary(event.target.checked)} />
          Review not necessary
        </label>
        <p>Select the record-linked reviewers who should receive this review request.</p>
        {['recruiter', 'salesperson'].map(role => {
          const reviewer = reviewers.find(item => String(item.userId) === String(selections[role]));
          return (
            <label key={role} className="ncf-reviewer-checkbox">
              <input
                type="checkbox"
                checked={Boolean(enabledRoles[role])}
                disabled={reviewNotNecessary || !reviewer}
                onChange={event => setEnabledRoles(previous => ({ ...previous, [role]: event.target.checked }))}
              />
              <span>{role === 'salesperson' ? 'Salesperson' : 'Recruiter'}{reviewer ? `: ${reviewer.name} (${reviewer.email})` : ' (no matching directory user)'}</span>
            </label>
          );
        })}
        <label className="ncf-additional-reviewers"><span>Additional recipient (optional)</span></label>
        <Typeahead value={null} onSelect={addRecipient} fetchOptions={searchRecipients} createOption={createRecipient} minChars={2} disabled={reviewNotNecessary} placeholder="Search users or groups, or type an email..." />
        {additionalRecipients.length > 0 && <div className="ncf-additional-recipient-list">{additionalRecipients.map(recipient => <div className="ncf-additional-recipient-row" key={recipient.email}><span>{recipient.name} ({recipient.email})</span><button type="button" className="btn btn-danger btn-sm" onClick={() => setAdditionalRecipients(previous => previous.filter(item => item.email !== recipient.email))} disabled={reviewNotNecessary}>Remove</button></div>)}</div>}
        <label className="ncf-review-message"><span>Message to recipients (optional)</span><textarea value={customMessage} onChange={event => setCustomMessage(event.target.value)} disabled={reviewNotNecessary} rows="4" maxLength="2000" placeholder="Add a message for the reviewers..." /></label>
        {error && <div className="alert alert-error">{error}</div>}
        <div className="modal-actions">
          <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <button type="button" className="btn btn-primary" onClick={onSend}>{reviewNotNecessary ? 'Save' : 'Send'}</button>
        </div>
      </div>
    </div>
  );
}

export default NcfReviewRequestModal;
